import type { FC } from 'react';
import { useCallback } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import InviteAlreadyAcceptedSvg from '../../assets/invite_already_accepted.svg';
import InviteAlreadyRejectedSvg from '../../assets/invite_already_rejected.svg';
import { useTranslation } from 'react-i18next';
import { ConnectionStatus } from '@pflegenavi/service-provider-shared/api-endpoints';
import { spAppMainPages } from '@pflegenavi/frontend/routing';
import { useNavigate } from 'react-router-dom';

interface AlreadyAcceptedInfoProps {
  connectionStatus: ConnectionStatus;
  accountAffiliationName: string;
}

export const AlreadyAcceptedInfo: FC<AlreadyAcceptedInfoProps> = ({
  connectionStatus,
  accountAffiliationName,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToHome = useCallback(() => {
    navigate(spAppMainPages.HOME);
  }, [navigate]);

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
      }}
    >
      <Stack
        sx={{
          gap: 3,
          maxWidth: 500,
        }}
      >
        <Stack
          sx={{
            gap: 0.5,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: 'primary.main',
            }}
          >
            {connectionStatus === ConnectionStatus.InviteRejected
              ? t(
                  'service-provider-app.already-responded.invitation-already-rejected'
                )
              : t(
                  'service-provider-app.already-responded.invitation-already-accepted'
                )}
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'grey.500',
            }}
          >
            {connectionStatus === ConnectionStatus.InviteRejected
              ? t(
                  'service-provider-app.already-responded.invitation-already-rejected-description',
                  { nursingHomeName: accountAffiliationName }
                )
              : t(
                  'service-provider-app.already-responded.invitation-already-accepted-description',
                  { nursingHomeName: accountAffiliationName }
                )}
          </Typography>
        </Stack>
        <Stack
          sx={{
            alignItems: 'center',
          }}
        >
          <img
            src={
              connectionStatus === ConnectionStatus.InviteRejected
                ? InviteAlreadyRejectedSvg
                : InviteAlreadyAcceptedSvg
            }
            width={250}
          />
        </Stack>

        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={handleGoToHome}
        >
          {t('service-provider-app.already-responded.go-to-home')}
        </Button>
      </Stack>
    </Stack>
  );
};
